module.exports = __webpack_public_path__ + "section-light-background.svg?32a887a00a2fd6f1d17eba14972839a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/section-light-background.svg
// module id = 137
// module chunks = 0